import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate' })
export class TruncantePipe implements PipeTransform {
    transform(value: string ): string {
        return value.substring(0, 200);
    }
}
